import { CloseButton } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import {
  useCreateWorkflowCamapaignMutation,
  useUpdateCampaignWorkFlowMutation,
} from "../../../../Services/campaign/CampaignMapping";

import { toast } from "react-toastify";
interface IProps {
  closeModal: any;
  workflowForEditAndCreate: any;
  refetch: any;
  selectedTeam: any;
  selectedCampaign: any;
}

const NewWorkflowModal: React.FC<IProps> = ({
  closeModal,
  workflowForEditAndCreate,
  refetch,
  selectedTeam,
  selectedCampaign,
}) => {
  const initialValues = {
    id: workflowForEditAndCreate.workflowEditEnabled
      ? workflowForEditAndCreate.workflowData.id
      : "",
    name: workflowForEditAndCreate.workflowEditEnabled
      ? workflowForEditAndCreate.workflowData.name
      : "",
    active_status: workflowForEditAndCreate.workflowEditEnabled
      ? workflowForEditAndCreate.workflowData.active_status
      : "",
    is_assigned_to_creator_on_close: true,
    resolved_status: null,
    closed_status: workflowForEditAndCreate.workflowEditEnabled
      ? workflowForEditAndCreate.workflowData.closed_status
      : "",
    reopen_status: workflowForEditAndCreate.workflowEditEnabled
      ? workflowForEditAndCreate.workflowData.reopen_status
      : "",
    closed_assignment_team: null,
    closed_visibility_team: null,
    in_progress_statuses: [],
    team: null,
    closed_status_visible: false,
  };

  const newWorkflowSchema = Yup.object().shape({
    name: Yup.string().required("Please provide a ticket name"),
    active_status: Yup.string().required("Please provide a active stage"),
    closed_status: Yup.string().required("Please provide a closed stage"),
  });

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formSubmissionStatus, setFormSubmissionStatus] = useState("");
  const [triggerNewWorkflowMutation] = useCreateWorkflowCamapaignMutation();
  const [triggerUpdateWorkflowMutation] = useUpdateCampaignWorkFlowMutation();

  const submitForm = async (valObj: any) => {
    const promise = new Promise((resolve, reject) => {});
    try {
      workflowForEditAndCreate.workflowEditEnabled
        ? triggerUpdateWorkflowMutation(valObj).then((res: any) => {
            if (res.data) {
              toast.success("Workflow update successfully");
              refetch();
              closeModal();
            } else alert("failed to update");
          })
        : triggerNewWorkflowMutation(valObj).then((res: any) => {
            console.log(res, "res");

            if (res.data) {
              toast.success("Workflow created successfully");
              refetch();
              closeModal();
            } else if (res.error) {
              const errorMsg =
                res.error.data?.err?.join(", ") ||
                "Failed to create a workflow";
              toast.error(errorMsg);
            } else {
              toast.error("Failed to create a workflow");
            }
          });
    } catch (error) {
      console.error("Error making the POST request:", error);
      setFormSubmissionStatus("Error submitting the form");
    } finally {
      setSubmitting(
        false
      ); /* Set submitting to false to enable the form again */
    }
    return promise;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: newWorkflowSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const formSubmissionValues = workflowForEditAndCreate.workflowEditEnabled
        ? {
            name: values.name,
            active_status: values.active_status,
            closed_status: values.closed_status,
            reopen_status: values.reopen_status,
            campaign: workflowForEditAndCreate.workflowData.campaign.id,
            closed_assignment_team:
              workflowForEditAndCreate.workflowData.closed_assignment_team,
            closed_visibility_team:
              workflowForEditAndCreate.workflowData.closed_visibility_team,
            id: workflowForEditAndCreate.workflowData.id,
            is_assigned_to_creator_on_close:
              workflowForEditAndCreate.workflowData
                .is_assigned_to_creator_on_close,
          }
        : {
            name: values.name,
            active_status: values.active_status,
            closed_status: values.closed_status,
            reopen_status: values.reopen_status,
            is_assigned_to_creator_on_close: true,
            closed_assignment_team: null,
            closed_visibility_team: null,
            progress_statuses: [],
            team: selectedTeam,
            campaign: selectedCampaign,
          };
      setLoading(true);
      submitForm(formSubmissionValues)
        .then((res: any) => {
          closeModal();
          if (res.data.signIn.status === 201) {
            /* setLoading(false) */
            closeModal()``;
          } else {
            /* setLoading(false) */
            setSubmitting(false);
          }
        })
        .catch((err: any) => {
          /* setLoading(false) */
          setSubmitting(false);
          console.error(err);
        });
    },
  });
  return (
    <div>
      <div className="text-end">
        <CloseButton onClick={closeModal} />
      </div>

      <form
        className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
        noValidate
        onSubmit={formik.handleSubmit}
      >
        <div className="text-center mb-4">
          <label className="form-label fs-2 fw-bolder text-dark card-title">
            {workflowForEditAndCreate.workflowEditEnabled ? "Edit" : "New"}{" "}
            workflow
          </label>
        </div>

        <div className="row g-5 g-xl-8 mb-6">
          {/*ticket name feed*/}
          <div className="col-xl-12">
            <div className="d-flex flex-column">
              <label className="required">Add workflow name</label>
              <input
                id="name"
                name="name"
                onChange={formik.handleChange}
                value={formik.values.name}
                type="text"
                className="form-control"
              />

              {formik.touched.name && formik.errors.name && (
                <div className="fv-plugins-message-container text-danger">
                  <span role="alert">{formik.errors.name}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row g-5 g-xl-8 mb-6">
          {/*active stage feed*/}
          <div className="col-xl-12">
            <div className="d-flex flex-column">
              <label className="required">Active stage</label>
              <input
                id="active_status"
                name="active_status"
                onChange={formik.handleChange}
                value={formik.values.active_status}
                type="text"
                className="form-control"
              />

              {formik.touched.active_status && formik.errors.active_status && (
                <div className="fv-plugins-message-container text-danger">
                  <span role="alert">{formik.errors.active_status}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row g-5 g-xl-8 mb-6">
          {/*closed stage feed*/}
          <div className="col-xl-12">
            <div className="d-flex flex-column">
              <label className="required">Closed stage</label>
              <input
                id="closed_status"
                name="closed_status"
                onChange={formik.handleChange}
                value={formik.values.closed_status}
                type="text"
                className="form-control"
              />

              {formik.touched.closed_status && formik.errors.closed_status && (
                <div className="fv-plugins-message-container text-danger">
                  <span role="alert">{formik.errors.closed_status}</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row g-5 g-xl-8 mb-6">
          {/*reopen stage feed*/}
          <div className="col-xl-12">
            <div className="d-flex flex-column">
              <label className="">Reopen stage</label>
              <input
                id="reopen_status"
                name="reopen_status"
                onChange={formik.handleChange}
                value={formik.values.reopen_status}
                type="text"
                className="form-control"
              />
            </div>
          </div>
        </div>

        <div className="text-end mt-6 mb-4">
          <button className={`btn btn-sm btn-primary`} type="submit">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewWorkflowModal;
